export const application = 'bright-academy';

export const apiURL = '/bright/api';

export const gaId = 'UA-91016801-4';

export const wsURL = 'https://www.learnwithbright.com';

export const rootUrl = 'https://admin.learnwithbright.academy';

export const academyURL = 'https://learnwithbright.academy';
